var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"c-button",on:{"click":_vm.onClick}},[_vm._v("ログイン")])}
var staticRenderFns = []

export { render, staticRenderFns }